if (!customElements.get('drawer-component')) {
  class DrawerComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Move to end of body if not already there
      if (document.body.lastElementChild !== this) {
        document.body.appendChild(this);
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('.drawer__overlay')?.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const triggerLink = document.getElementById(this.dataset.triggerId);

      if (triggerLink) {
        triggerLink.setAttribute('role', 'button');
        triggerLink.setAttribute('aria-haspopup', 'dialog');
        triggerLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(triggerLink);
        });
        triggerLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(triggerLink);
          }
        });
      }
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : this.querySelector('.drawer-component');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);

      clearTimeout(this.timeout);
      
      this.timeout = setTimeout(() => {
        document.body.classList.remove('overflow-hidden');
      }, getComputedStyle(document.querySelector(':root')).getPropertyValue('--duration-default').replace('s', '') * 1000);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      const triggerLink = document.getElementById(this.dataset.triggerId);

      if (triggerLink) {
        triggerLink.dispatchEvent(new Event('click'))
      }
    }

  }

  customElements.define('drawer-component', DrawerComponent);
}